import { createFileRoute } from '@tanstack/react-router';
import { ContasPagar } from '@/features/contas-pagar/page';

export const Route = createFileRoute('/a/contas-pagar/')({
    component: ContasPagar,
});
